import React, {Component, Fragment} from 'react';
import {observer} from 'mobx-react';

import Page from 'lib/struct/page/Page';
import Tabs from 'lib/struct/Tabs';
import SaveButton from 'lib/struct/page/SaveButton';
import FixedFooter from 'lib/struct/page/FixedFooter';

import HeaderBar from './header_bar/HeaderBar';
import GroupsSettingsComponent from './group_settings/GroupsSettingsComponent';
import GeneralStorefrontSettings from './general_settings/GeneralStorefrontSettings';
import MarkupStyleThemeStorefrontSettings from './markup_styles_settings/MarkupStyleThemeStorefrontSettings';
import MarkupTemplateThemeSettings from './markup_template_settings/MarkupTemplateThemeSettings';

@observer export default class SettingsPage extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;

		const tabs = [{
			label: 'Общие',
			content: (
				<Fragment>
					<GeneralStorefrontSettings context={context} />
					<GroupsSettingsComponent context={context} />
				</Fragment>
			),
		}];

		if (context.current_style_theme_id) {
			tabs.push({
				label: 'Оформление',
				content: (
					<MarkupStyleThemeStorefrontSettings context={context} />
				),
			});
		}

		if (context.current_theme_id) {
			tabs.push({
				label: 'Шаблоны',
				content: (
					<MarkupTemplateThemeSettings context={context} />
				),
			});
		}

		return (
			<Page
				header={(<HeaderBar/>)}
				footer={(
					<FixedFooter>
						<SaveButton
							onClick={() => context.saveSettings()}
							state={context.save_state}
						/>
					</FixedFooter>
				)}
			>
				<Tabs tabs={tabs} />
			</Page>
		);
	}
}